import { useEffect, useMemo, useState } from 'react';
import { api, BracketStage, TimbaPrediction } from '../api/client';
import { getIdentity } from './identity';
import { timbaBracketSlots, SlotDisp } from './timbaBracket';

// Rivales tentativos de toda la llave (cascada desde mis pronósticos), indexados por nº de partido.
// Carga la llave + mis pronósticos una vez. Sirve para mostrar los cruces futuros con equipos.
export function useMyTimbaSlots(): Map<number, [SlotDisp, SlotDisp]> {
  const [stages, setStages] = useState<BracketStage[]>([]);
  const [preds, setPreds] = useState<Record<number, TimbaPrediction>>({});

  useEffect(() => {
    let alive = true;
    api.bracket().then((d) => alive && setStages(d.stages)).catch(() => {});
    let pub = '';
    try {
      pub = getIdentity().pub;
    } catch {
      /* sin identidad */
    }
    if (pub) {
      api
        .timbaPredictions(pub)
        .then((d) => {
          if (!alive) return;
          const rec: Record<number, TimbaPrediction> = {};
          d.predictions.forEach((p) => (rec[p.num] = p));
          setPreds(rec);
        })
        .catch(() => {});
    }
    return () => {
      alive = false;
    };
  }, []);

  return useMemo(() => timbaBracketSlots(stages, preds), [stages, preds]);
}
